import { useLingui } from '@lingui/react';
import React, { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import BillingTextV2 from '..';
import { isAddonsChanged } from '../../../helper/isAddonsChanged';
import { calculateSubscriptionTotal } from '../../OrderSummaryV2/helper/calculateSubscriptionTotal';
import { addonNewMode, processAddonPacks } from '../../AddonTogglerList/helper/processAddonPacks';
import { getPreviewInvoiceType } from '../../OrderSummaryV2/helper/getPreviewInvoiceType';
import dayjs from 'dayjs';

export default function SelfBillingTextInfo() {
    useLingui();

    const subscription = useSelector(state => state.Subscription.subscription, shallowEqual);
    const planInUse = useSelector(state => state.Subscription.planInUse, shallowEqual);
    const subscriptionAddonsInUse = useSelector(
        state => state.Subscription.subscriptionAddonsInUse,
        shallowEqual,
    );
    const selectedPlan = useSelector(state => state.Plan.selectedPlan, shallowEqual);
    const billingCycle = useSelector(state => state.Plan.billingCycle);

    const addonPacks = useSelector(state => state.Quota.addonPacks, shallowEqual);
    const planAddonsBefore = useSelector(state => state.Subscription.subscriptionAddonsInUse, shallowEqual);
    const planAddonsAfter = useSelector(state => state.Plan.planAddons, shallowEqual);
    const step = useSelector(state => state.Subscription.modalCurrentStep);

    const {
        status,
        trial_ends_at,
        billing_cycle_anchor,
        previous_plan_valid_until: previousPlanValidUntil,
    } = subscription;

    const processedPlanAddonsBefore = useMemo(() => processAddonPacks({
        addonPacks,
        planAddons: planAddonsBefore,
        billingCycle: planInUse?.billing_cycle,
        removeZeroQty: false,
        upcomingSubAddons: [],
        filterPlanAddonsConfig: { mode: 'removeObject', selectedPlanType: planInUse?.type },
        filterNewMode: planInUse?.is_new ? addonNewMode.newOnly : addonNewMode.oldOnly,
    }), [addonPacks, planAddonsBefore, planInUse]);
    const processedPlanAddonsAfter = useMemo(() => processAddonPacks({
        addonPacks,
        planAddons: planAddonsAfter,
        billingCycle,
        removeZeroQty: false,
        upcomingSubAddons: [],
        filterPlanAddonsConfig: { mode: 'removeObject', selectedPlanType: selectedPlan?.type },
        filterNewMode: selectedPlan?.is_new ? addonNewMode.newOnly : addonNewMode.oldOnly,
    }), [addonPacks, planAddonsAfter, billingCycle, selectedPlan]);

    const subtotalsBefore = calculateSubscriptionTotal(planInUse, processedPlanAddonsBefore);
    const subtotalsAfter = calculateSubscriptionTotal(selectedPlan, processedPlanAddonsAfter);
    const isBillingCycleChanged = planInUse?.billing_cycle !== billingCycle;

    const parsedPreviewType = getPreviewInvoiceType(
        subtotalsBefore.subtotal,
        subtotalsAfter.subtotal,
        isBillingCycleChanged,
        status,
    );

    // If currently still in trial, will definitely consider as plan changed
    // https://bukku.atlassian.net/browse/ENG-3634?focusedCommentId=20716
    const stillInTrial = trial_ends_at && dayjs().isBefore(dayjs(trial_ends_at));
    const isPlanChanged = stillInTrial || (selectedPlan && (planInUse.id !== selectedPlan.id));

    const addonsChanged = isAddonsChanged(subscriptionAddonsInUse, planAddonsAfter);
    const isInBetweenDowngradePeriod = previousPlanValidUntil ?
        dayjs().isSameOrBefore(dayjs(previousPlanValidUntil)) :
        false;
    console.log('aaa SelfBillingTxtInfo', {planInUse, selectedPlan, subscription, parsedPreviewType, subtotalsBefore, subtotalsAfter});

    // console.log('aaa SelfBillingTxtInfo', {
    //     subscription,
    //     parsedPreviewType,
    //     addonsChanged,
    //     isPlanChanged,
    //     subscriptionInfo: {
    //         trialEndsAt: trial_ends_at,
    //         billingCycleAnchor: billing_cycle_anchor,
    //         billingCycle: planInUse?.billing_cycle,
    //     }});

    if (selectedPlan) {
        return (
            <BillingTextV2
                previewType={parsedPreviewType}
                isAddonsChanged={addonsChanged}
                isPlanChanged={isPlanChanged}
                subscriptionInfo={{
                    trialEndsAt: trial_ends_at,
                    billingCycleAnchor: billing_cycle_anchor,
                    billingCycle: planInUse?.billing_cycle,
                }}
                hideComparePlansLink={step > 1}
                isInBetweenDowngradePeriod={isInBetweenDowngradePeriod}
            />
        );
    }

    return null;
}
